var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankTouchpointAndCustomerCareOnline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3498.000000, -437.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank-touchpoint-and-customer-care/Online",
    transform: "translate(3498.000000, 437.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.733017,20 L31.7089994,27.22 C32.3769955,28.75 31.8549985,30 30.5520063,30 L30.5520063,30 L1.44817856,30 C0.144186285,30 -0.376810631,28.75 0.291185414,27.22 L0.291185414,27.22 L3.21716809,20 L28.733017,20 Z M20.0000687,24 L12.0001161,24 L10.0001279,28 L22.0000569,28 L20.0000687,24 Z M29.0004154,2 L29.0004154,16 C29.0004154,16.703 28.8704162,17.373 28.6484175,18 L28.6484175,18 L3.3515673,18 C3.12856862,17.374 3.00056937,16.703 3.00056937,16 L3.00056937,16 L3.00056937,2 L29.0004154,2 Z",
    id: 117
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTouchpointAndCustomerCareOnline);
export default __webpack_public_path__ + "static/media/bank-touchpoint-and-customer-care-online.0e2072c1.svg";
export { ForwardRef as ReactComponent };